class SnowAnimation {
  constructor(config) {
    this.config = config;
    this.canvas = null;
    this.ctx = null;
    this.snowflakes = [];
    this.animationId = null;
    this.isMobile = window.innerWidth <= 768;

    this.init();
  }

  init() {
    if (this.shouldDisable()) return;

    this.setupCanvas();
    this.createSnowflakes();
    this.animate();
    this.setupEventListeners();
  }

  shouldDisable() {
    const { enableSnow, mobile_disable, reduce_motion } = this.config;

    if (!enableSnow) return true;
    if (reduce_motion && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;
    if (mobile_disable && this.isMobile) return true;

    return false;
  }

  setupCanvas() {
    const container = document.querySelector(`[data-section-id="${this.config.sectionId}"] [data-snow-container]`);
    this.canvas = container.querySelector('[data-snow-canvas]');
    this.ctx = this.canvas.getContext('2d');

    this.resizeCanvas();
    container.style.zIndex = this.config.zIndex;
  }

  resizeCanvas() {
    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;
  }

  createSnowflakes() {
    this.snowflakes = [];

    for (let i = 0; i < this.config.snowCount; i++) {
      this.snowflakes.push({
        x: Math.random() * this.canvas.width,
        y: Math.random() * this.canvas.height,
        radius: Math.random() * this.config.snowSize + 1,
        speed: Math.random() * this.config.snowSpeed + 0.5,
        wind: (Math.random() - 0.5) * this.config.snowWind,
        opacity: Math.random() * 0.5 + 0.5,
        swing: Math.random() * Math.PI * 2,
        swingSpeed: Math.random() * 0.02 + 0.01
      });
    }
  }

  drawSnowflakes() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.fillStyle = this.config.snowColor;

    this.snowflakes.forEach(flake => {
      this.ctx.globalAlpha = flake.opacity;
      this.ctx.beginPath();
      this.ctx.arc(flake.x, flake.y, flake.radius, 0, Math.PI * 2);
      this.ctx.fill();
    });

    this.ctx.globalAlpha = 1;
  }

  updateSnowflakes() {
    this.snowflakes.forEach(flake => {
      flake.swing += flake.swingSpeed;
      flake.y += flake.speed;
      flake.x += flake.wind + Math.sin(flake.swing) * 0.5;

      if (flake.y > this.canvas.height) {
        this.resetFlake(flake);
      }

      if (flake.x > this.canvas.width + 10) {
        flake.x = -10;
      } else if (flake.x < -10) {
        flake.x = this.canvas.width + 10;
      }
    });
  }

  resetFlake(flake) {
    flake.x = Math.random() * this.canvas.width;
    flake.y = -10;
    flake.radius = Math.random() * this.config.snowSize + 1;
  }

  animate() {
    this.drawSnowflakes();
    this.updateSnowflakes();
    this.animationId = requestAnimationFrame(() => this.animate());
  }

  setupEventListeners() {
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.resizeCanvas();
        this.createSnowflakes();
      }, 250);
    });

    if (this.config.interactive) {
      let mouseX = 0;
      let mouseY = 0;

      document.addEventListener('mousemove', (e) => {
        mouseX = e.clientX;
        mouseY = e.clientY;

        this.snowflakes.forEach(flake => {
          const dx = flake.x - mouseX;
          const dy = flake.y - mouseY;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < 100) {
            const force = (100 - distance) / 100;
            flake.x += dx * 0.02 * force;
            flake.y += dy * 0.02 * force;
          }
        });
      });
    }
  }

  destroy() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }

    if (this.ctx) {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
  }
}

if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.snow-animation-section');
    if (section) {
      const sectionId = section.dataset.sectionId;
      const config = window.snowConfig && window.snowConfig[sectionId];
      if (config) {
        new SnowAnimation(config);
      }
    }
  });
}